import { HttpClient, HttpHeaders, HttpRequest, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class FileService {

  httpHeaders = new HttpHeaders({
  });

  constructor(
    private http: HttpClient
  ) { }

  //*** descargar ficha medica de pasajero
  descargarFicha(idPasajero: Number): any {
		return this.http.get(environment.api + 'api/pasajero/downloadFichaMedica?id='+idPasajero, {responseType: 'blob'});
  }

  //*** descargar imagen de documento de identificacion de pasajero
  descargarDoc(idPasajero: Number): any {
		return this.http.get(environment.api + 'api/pasajero/downloadDocumento?id='+idPasajero, {responseType: 'blob'});
  }

  //*** descargar planilla de pasajero
  descargarPlanilla(idPasajero: Number): any {
		return this.http.get(environment.api + 'api/pasajero/check?id='+idPasajero, {responseType: 'blob'});
  }

  //*** descargar Comprobante de reservacion
  descargarComprobante(idReservacion: String): any {
		return this.http.get(environment.api + 'api/reservacion/ficha?id='+idReservacion, {responseType: 'blob'});
  }

}
